
import * as defaultImport from "@splunk/react-icons/Triangle";
export * from "@splunk/react-icons/Triangle";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
